import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useVersionCheck } from './hooks/useVersionCheck';
import Login from './pages/Login/Login';
import MainLayout from './components/MainLayout/MainLayout';
import HomeSub from './pages/Home/HomeSub';
import HomeBak from './pages/Home/HomeBak';
import EnterpriseDashboard from './pages/Home/EnterpriseDashboard';
import ValueAddedOrder from './pages/Order/ValueAddedOrder/ValueAddedOrder';
import FourGOrder from './pages/Order/FourGOrder/FourGOrder';
import ProduceAuthPurchase from './pages/Order/ProduceAuthPurchase/ProduceAuthPurchase';
import EnterpriseProducePurchase from './pages/Order/EnterpriseProducePurchase/EnterpriseProducePurchase';
import SelfSaaS from './pages/AppService/SelfSaaS/SelfSaaS';
import SaaSAudit from './pages/AppService/SaaSAudit/SaaSAudit';
import PrivateDeploy from './pages/AppService/PrivateDeploy/PrivateDeploy';
import PrivateDeployAudit from './pages/AppService/PrivateDeploy/PrivateDeployAudit';
import MyCustom from './pages/AppService/OEMCustom/MyCustom';
import CustomManage from './pages/AppService/OEMCustom/CustomManage';
import CustomDetail from './pages/AppService/OEMCustom/CustomDetail';
import CustomDetailAudit from './pages/AppService/OEMCustom/CustomDetailAudit';
import AgentList from './pages/Agent/AgentList';
import AgentConfig from './pages/Agent/AgentConfig';
import ModelManage from './pages/Agent/ModelManage';
import TriggerEventManage from './pages/Agent/TriggerEventManage';
import SubEnterprise from './pages/Enterprise/SubEnterprise/SubEnterprise';
import SubEnterpriseChild from './pages/Enterprise/SubEnterpriseChild/SubEnterpriseChild';
import ChildEnterprise from './pages/Enterprise/ChildEnterprise/ChildEnterprise';
import EnterpriseAdmin from './pages/Enterprise/EnterpriseAdmin/EnterpriseAdmin';
import BrandSetting from './pages/Enterprise/BrandSetting/BrandSetting';
import EnterpriseInfo from './pages/Enterprise/EnterpriseInfo/EnterpriseInfo';
import DeviceTransfer from './pages/Device/DeviceTransfer/index';
import ReferencedProductList from './pages/Product/ReferencedProduct/ReferencedProductList';
import IotCategory from './pages/Model/IotCategory/IotCategory';
import StandardAbility from './pages/Model/Device/StandardAbility';
import CustomAbility from './pages/Model/Device/CustomDevice/CustomAbility';
import AlgorithmLibrary from './pages/Model/AlgorithmLibrary/AlgorithmLibrary';
import EventLibrary from './pages/Model/EventLibrary/EventLibrary';
import ProductDevelop from './pages/Product/ProductDevelop/ProductDevelop';
import ProductDetail from './pages/Product/ProductDevelop/ProductDetail';
import ProductInformation from './pages/Product/ProductDevelop/ProductInformation';
import AppConfigDetail from './pages/Product/ProductDevelop/AppConfigDetail';
import ProductAudit from './pages/Product/ProductAudit/ProductAudit';
import ProductManage from './pages/Product/ProductAudit/ProductManage';
import NetworkUnit from './pages/Product/NetworkUnit/NetworkUnit';
import EcosystemList from './pages/Product/Ecosystem/EcosystemList';
import EcosystemDetail from './pages/Product/Ecosystem/EcosystemDetail';
import MySolutions from './pages/Product/Ecosystem/MySolutions';
import EcosystemAudit from './pages/Product/Ecosystem/EcosystemAudit';
import PlanDevelop from './pages/Product/PlanDevelop/PlanDevelop';
import AuthorizedSaaS from './pages/Product/AuthorizedSaaS/AuthorizedSaaS';
import FirmwareNew from './pages/Firmware/FirmwareNew/FirmwareNew';
import FirmwareDetail from './pages/Firmware/FirmwareNew/FirmwareDetail';
import FirmwareModelConfig from './pages/Firmware/FirmwareNew/FirmwareModelConfig';
import ModelView from './pages/Firmware/FirmwareNew/ModelView';
import ProduceAccount from './pages/Produce/Account/ProduceAccount';
import DeviceTag from './pages/Produce/DeviceTag/DeviceTag';
import DeviceList from './pages/Device/DeviceList/DeviceList';
import AllDeviceList from './pages/Device/AllDeviceList/AllDeviceList';
import DeviceDetail from './pages/Device/DeviceDetail/DeviceDetail';
import DeviceMaintenance from './pages/Device/DeviceMaintenance/DeviceMaintenance';
import DeviceStatistics from './pages/Device/DeviceStatistics/DeviceStatistics';
import DeviceGroups from './pages/Device/DeviceGroups/DeviceGroups';
import MaintenanceDetail from './pages/Device/DeviceMaintenance/MaintenanceDetail';
import FirmwareOta from './pages/Device/FirmwareOta/FirmwareOta';
import OtaDeviceDetail from './pages/Device/FirmwareOta/OtaDeviceDetail';
import FirmwareOtaUpgradeNum from './pages/Device/FirmwareOta/FirmwareOtaUpgradeNum';
import MenuConfig from './pages/System/MenuConfig/MenuConfig';
import GeneralRoleManagement from './pages/System/RoleManagement/RoleManagement';
import AccountManagement from './pages/System/AccountManagement/AccountManagement';
import MenuGroup from './pages/System/MenuGroup/MenuGroup';
import ReleaseNotes from './pages/System/ReleaseNotes/ReleaseNotes';
import AppManage from './pages/AppService/AppManage/AppManage';
import OperationConfig from './pages/AppService/AppManage/OperationConfig';
import AppAudit from './pages/AppService/AppManage/AppAudit';
import AppManageList from './pages/AppService/AppManage/AppManageList';
import PlatformMerchant from './pages/AppService/MerchantManage/PlatformMerchant';
import EnterpriseMerchant from './pages/AppService/MerchantManage/EnterpriseMerchant';
import PackageManage from './pages/AppService/PackageManage/PackageManage';
import PackageCombination from './pages/AppService/PackageCombination/PackageCombination';
import AppPackage from './pages/AppService/AppPackage/AppPackage';
import PackageGift from './pages/AppService/PackageManage/PackageGift';
import PackageSwitch from './pages/AppService/PackageSwitch/PackageSwitch';
import PackageTransfer from './pages/AppService/PackageTransfer/PackageTransfer';
import MallOperation from './pages/Operation/MallOperation';
import MallPackageConfig from './pages/Operation/MallPackageConfig';
import RecommendOperation from './pages/Operation/RecommendOperation';
import CustomSaleEntry from './pages/Operation/CustomSale/CustomSaleEntry';
import CustomSaleConfig from './pages/Operation/CustomSale/CustomSaleConfig';
import UserSegment from './pages/Operation/UserSegment';
import TrialConvert from './pages/Operation/TrialConvert';
import AdPlatformManage from './pages/Operation/AdPlatformManage';
import CouponList from './pages/Coupon/CouponList';
import CouponRecords from './pages/Coupon/CouponRecords';
import CouponIssueRecords from './pages/Coupon/CouponIssueRecords';
import AdWhitelist from './pages/Ad/AdWhitelist';
import GlobalAdSlot from './pages/Ad/GlobalAdSlot';
import GlobalAdStrategy from './pages/Ad/GlobalAdStrategy';
import ExchangeRate from './pages/AppService/PackageManage/ExchangeRate';
import VendorDefinition from './pages/FourG/VendorDefinition/VendorDefinition';
import CardManage from './pages/FourG/CardManage/CardManage';
import VendorManage from './pages/FourG/VendorManage/VendorManage';
import PersonalCenter from './pages/PersonalCenter/PersonalCenter';
import ConsumptionAccount from './pages/CostCenter/ConsumptionAccount';
import RechargeAudit from './pages/Finance/RechargeAudit';
import CreditLimit from './pages/Finance/CreditLimit';
import WithdrawAudit from './pages/Finance/WithdrawAudit';
import DirectTopup from './pages/Finance/DirectTopup/DirectTopup';
import InvoiceManage from './pages/CostCenter/InvoiceManage';
import IncomeAccount from './pages/CostCenter/IncomeAccount';
import IncomeWithdraw from './pages/CostCenter/IncomeWithdraw';
import InvoiceCenter from './pages/CostCenter/InvoiceCenter';
import InvoiceManagePage from './pages/CostCenter/InvoiceManagePage';
import InvoiceApply from './pages/CostCenter/InvoiceApply';
import BillManage from './pages/Commission/BillManage/BillManage';
import AdCommissionBill from './pages/Finance/AdCommissionBill';
import PrivateDeployBill from './pages/Finance/PrivateDeployBill/PrivateDeployBill';
import TrafficGroup from './pages/Finance/TrafficGroup/TrafficGroup';
import DeviceTrafficBill from './pages/CostCenter/DeviceTrafficBill';
import DeviceTrafficStat from './pages/CostCenter/DeviceTrafficStat';
import AppProfit from './pages/Share/AppProfit/AppProfit';
import ShareReassign from './pages/Share/ShareReassign/ShareReassign';
import ShareBilling from './pages/Share/ShareBilling/ShareBilling';
import ShareIncome from './pages/Share/ShareIncome/ShareIncome';
import BusinessConfig from './pages/Share/BusinessConfig/BusinessConfig';
import AdProfitConfig from './pages/Share/AdProfit/Config';
import AdProfitAgain from './pages/Share/AdProfit/Again';
import AdProfitExpend from './pages/Share/AdProfit/Expend';
import AdProfitIncome from './pages/Share/AdProfit/Income';
import AdProfitSupervise from './pages/Share/AdProfit/Supervise';
import ProduceConfig from './pages/Produce/ProduceConfig/ProduceConfig';
import ProdTestAfterSales from './pages/Produce/ProdTestAfterSales/ProdTestAfterSales';
import ProdTestStatistics from './pages/Produce/ProdTestStatistics/ProdTestStatistics';
import ProduceOrder from './pages/Produce/ProduceOrder/ProduceOrder';
import CreateOrder from './pages/Produce/ProduceOrder/CreateOrder';
import EditOrder from './pages/Produce/ProduceOrder/EditOrder';
import OrderDetail from './pages/Produce/ProduceOrder/OrderDetail';
import UniqueIdLicense from './pages/Produce/UniqueIdLicense/UniqueIdLicense';
import DeviceOwnershipLog from './pages/Produce/DeviceOwnershipLog/DeviceOwnershipLog';
import ChangeNumberOrder from './pages/Produce/ChangeNumberOrder/ChangeNumberOrder';
import ManualChange from './pages/Produce/ManualChange/ManualChange';
import ServiceRegion from './pages/Dispatch/ServiceRegion/ServiceRegion';
import ProductDispatch from './pages/Dispatch/ProductDispatch/ProductDispatch';
import DeviceDispatch from './pages/Dispatch/DeviceDispatch/DeviceDispatch';
import DeviceDistribution from './pages/Distribution/DeviceDistribution/DeviceDistribution';
import AgentDistribution from './pages/Distribution/AgentDistribution/AgentDistribution';
import ToolchainManage from './pages/Compile/ToolchainManage/ToolchainManage';
import CompileTask from './pages/Compile/CompileTask/CompileTask';
import SdkVersion from './pages/Compile/SdkVersion/SdkVersion';
import LicenseQuery from './pages/Device/LicenseQuery';
import LicenseQueryNew from './pages/Device/LicenseQueryNew';
import AuditLog from './pages/AuditLog';
import TimelinePage from './pages/Announcement/Announcement';
import OrderQuery from './pages/Customer/OrderQuery/index';
import CustomerList from './pages/Customer/CRM/CustomerList';
import CustomerDetail from './pages/Customer/CRM/CustomerDetail';
import ServiceTracking from './pages/Customer/ServiceTracking/ServiceTracking';
import TagManage from './pages/Customer/CRM/TagManage';
import TicketList from './pages/Customer/TicketManage/TicketList';
import TicketDetail from './pages/Customer/TicketManage/TicketDetail';
import AgentAccountList from './pages/Customer/AgentManage/AgentList';
import TicketCreate from './pages/Customer/TicketEnterprise/TicketCreate';
import TicketMyList from './pages/Customer/TicketEnterprise/TicketMyList';
import TicketMyDetail from './pages/Customer/TicketEnterprise/TicketMyDetail';
import SolutionDashboard from './pages/Statistics/SolutionDashboard/SolutionDashboard';
import DeviceDashboard from './pages/Statistics/DeviceDashboard/DeviceDashboard';
import OrderDashboard from './pages/Statistics/OrderDashboard/OrderDashboard';
import AppAdRevenue from './pages/Statistics/AppAdRevenue/AppAdRevenue';
import FourGRevenue from './pages/Statistics/FourGRevenue/FourGRevenue';
import DeviceBrand from './pages/Statistics/DeviceBrand/DeviceBrand';

// 流量池配置
import PoolManage from './pages/TrafficPool/PoolManage/PoolManage';
import TrafficCardManage from './pages/TrafficPool/CardManage/CardManage';
import TrafficPackageList from './pages/TrafficPool/PackageList/PackageList';
import TrafficPackageEdit from './pages/TrafficPool/PackageEdit/PackageEdit';
import TrafficOrderList from './pages/TrafficPool/OrderList/OrderList';

import {
    RocketOutlined,
    ShoppingOutlined,
    HddOutlined,
    PieChartOutlined,
    UserOutlined
} from '@ant-design/icons';
import { Row, Col, Card } from 'antd';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import 'antd/dist/reset.css';
import './App.css';

// 简单的鉴权组件
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('user_token');
  return token ? children : <Navigate to="/login" />;
};

const Home = () => {
  return (
    <div style={{ padding: '24px', minHeight: '100%' }}>
      {/* 顶部通栏 */}
      <div style={{ 
        background: 'linear-gradient(90deg, #5b64d1 0%, #8d62b6 100%)', 
        padding: '40px', 
        borderRadius: '12px',
        color: 'white',
        position: 'relative',
        marginBottom: '24px'
      }}>
        <h1 style={{ fontSize: '32px', marginBottom: '8px' }}>晚上好，admin!</h1>
        <p style={{ opacity: 0.8 }}>欢迎使用鹤梦云生态平台</p>
        <div style={{ position: 'absolute', right: '40px', bottom: '20px', fontSize: '64px', opacity: 0.2 }}>
          <PieChartOutlined />
        </div>
      </div>

      {/* 快捷入口标题 */}
      <div style={{ marginBottom: '16px', fontWeight: 'bold', fontSize: '16px' }}>
         <RocketOutlined style={{ marginRight: '8px' }} /> 快捷入口
      </div>

      {/* 卡片区域 */}
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Card hoverable style={{ textAlign: 'center', borderRadius: '12px' }}>
            <div style={{ fontSize: '32px', color: '#1890ff', marginBottom: '12px', background: '#e6f7ff', padding: '16px', borderRadius: '12px' }}>
              <ShoppingOutlined />
            </div>
            <h3 style={{ margin: '8px 0' }}>产品管理</h3>
            <p style={{ color: '#888', fontSize: '12px' }}>创建和管理产品</p>
          </Card>
        </Col>
        <Col span={6}>
          <Card hoverable style={{ textAlign: 'center', borderRadius: '12px' }}>
             <div style={{ fontSize: '32px', color: '#52c41a', marginBottom: '12px', background: '#f6ffed', padding: '16px', borderRadius: '12px' }}>
              <HddOutlined />
            </div>
            <h3 style={{ margin: '8px 0' }}>设备管理</h3>
            <p style={{ color: '#888', fontSize: '12px' }}>查看和管理设备</p>
          </Card>
        </Col>
        <Col span={6}>
          <Card hoverable style={{ textAlign: 'center', borderRadius: '12px' }}>
             <div style={{ fontSize: '32px', color: '#fa8c16', marginBottom: '12px', background: '#fff7e6', padding: '16px', borderRadius: '12px' }}>
              <PieChartOutlined />
            </div>
            <h3 style={{ margin: '8px 0' }}>数据统计</h3>
            <p style={{ color: '#888', fontSize: '12px' }}>查看生产数据</p>
          </Card>
        </Col>
        <Col span={6}>
          <Card hoverable style={{ textAlign: 'center', borderRadius: '12px' }}>
             <div style={{ fontSize: '32px', color: '#ff4d4f', marginBottom: '12px', background: '#fff1f0', padding: '16px', borderRadius: '12px' }}>
              <UserOutlined />
            </div>
            <h3 style={{ margin: '8px 0' }}>用户信息</h3>
            <p style={{ color: '#888', fontSize: '12px' }}>管理个人信息</p>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const Placeholder = ({ title }) => (
  <div style={{ padding: '24px', background: '#fff', margin: '24px', borderRadius: '8px', minHeight: 'calc(100vh - 120px)' }}>
    <h2 style={{ fontSize: '20px', fontWeight: '500', marginBottom: '8px' }}>{title}</h2>
    <p style={{ fontSize: '14px', color: '#999' }}>页面开发中......</p>
  </div>
);

// 检查版本号

// const CURRENT_VERSION = "1.0.3";

function App() {
  // 启用版本检查，每30秒检查一次
  useVersionCheck(30000);
  //     try {
  //       const res = await fetch('/version.json?t=' + Date.now());
  //       const data = await res.json();

  //       if (data.version !== CURRENT_VERSION) {
  //         // 发现新版本，弹出提示而不是直接刷新
  //         Modal.confirm({
  //           title: '系统更新提示',
  //           content: `检测到新版本 (v${data.version})，为了确保您的操作正常，请刷新页面加载最新配置。`,
  //           okText: '立即刷新',
  //           cancelText: '稍后处理',
  //           onOk: () => window.location.reload(true),
  //         });
  //       }
  //     } catch (e) {
  //       console.error('Version check failed:', e);
  //     }
  //   }

  // // 每1分钟检查一次
  // const timer = setInterval(checkVersion, 1 * 60 * 1000);
    
  //   // 初始加载也检查一次
  //   checkVersion();

  //   return () => clearInterval(timer);
  // }, []);

  return (
    <ConfigProvider locale={zhCN}>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        {/* Wrap all authenticated routes with MainLayout */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <MainLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/home/dashboard" element={<EnterpriseDashboard />} />
                  <Route path="/home/bak" element={<HomeBak />} />
                  <Route path="/home/sub" element={<HomeSub />} />
                  <Route path="/personal-center" element={<PersonalCenter />} />
                  
                  {/* 固件管理 */}
                  <Route path="/firmware" element={<FirmwareNew />} />
                    <Route path="/firmware/version" element={<FirmwareDetail />} />
                    <Route path="/firmware/model-config" element={<FirmwareModelConfig />} />
                    <Route path="/firmware/model-view" element={<ModelView />} />
                  
                  <Route path="/primary-accounts" element={<Placeholder title="主要账户" />} />
                  
                  {/* 物模型管理 */}
                  <Route path="/model/iot" element={<IotCategory />} />
                  <Route path="/model/device" element={<StandardAbility />} />
                   <Route path="/model/customdevice" element={<CustomAbility />} />
                    <Route path="/model/algorithm" element={<AlgorithmLibrary />} />
                    <Route path="/model/event" element={<EventLibrary />} />
                  <Route path="/model/ability" element={<Placeholder title="能力库" />} />
                  
                  {/* 产品管理 */}
                  <Route path="/product/audit" element={<ProductAudit />} />
                  <Route path="/product/audit/manage" element={<ProductManage />} />
                  <Route path="/product" element={<ProductDevelop />} />
                  <Route path="/product/develop" element={<ProductDetail />} />
                  <Route path="/product/info" element={<ProductInformation />} />
                  <Route path="/product/app" element={<AppConfigDetail />} />
                  <Route path="/product/network-unit" element={<NetworkUnit />} />
                  <Route path="/product/ecosystem" element={<EcosystemList />} />
                  <Route path="/product/ecosystem/detail" element={<EcosystemDetail />} />
                  <Route path="/product/my-solutions" element={<MySolutions />} />
                   <Route path="/product/ecosystem-audit" element={<EcosystemAudit />} />
                   <Route path="/product/plan" element={<PlanDevelop />} />
                   <Route path="/product/authorized-saas" element={<AuthorizedSaaS />} />
                  
                  {/* 生产管理 */}
                  <Route path="/produce/config" element={<ProduceConfig />} />
                  <Route path="/production/productionOrder" element={<ProduceOrder />} />
                  <Route path="/production/productionOrder/create" element={<CreateOrder />} />
                  <Route path="/production/productionOrder/edit" element={<EditOrder />} />
                  <Route path="/production/productionOrder/detail" element={<OrderDetail />} />
                  <Route path="/production/prodTestAccount" element={<ProduceAccount />} />
                  <Route path="/production/prodTestAfterSales" element={<ProdTestAfterSales />} />
                  <Route path="/production/prodTestStatistics" element={<ProdTestStatistics />} />
                  <Route path="/production/uniqueid-license" element={<UniqueIdLicense />} />
                  <Route path="/production/device-ownership" element={<DeviceOwnershipLog />} />
                  <Route path="/production/change-number-order" element={<ChangeNumberOrder />} />
                  <Route path="/production/manual-change" element={<ManualChange />} />
                  <Route path="/produce/tag" element={<DeviceTag />} />
                  <Route path="/produce/overview" element={<Placeholder title="生产概览" />} />
                  
                   {/* 设备管理 */}
                   <Route path="/device/license" element={<LicenseQuery />} />
                   <Route path="/device/license-query" element={<LicenseQueryNew />} />
                   <Route path="/device/all" element={<DeviceList />} />
                  <Route path="/device/list" element={<AllDeviceList />} />
                  <Route path="/device/transfer" element={<DeviceTransfer />} />
                  <Route path="/device/info" element={<DeviceDetail />} />
                  <Route path="/device/group" element={<Placeholder title="分组管理" />} />
                  <Route path="/device/firmware/ota" element={<FirmwareOta />} />
                  <Route path="/device/firmware/ota/devices" element={<OtaDeviceDetail />} />
                  <Route path="/device/firmware/ota/upgradeNum" element={<FirmwareOtaUpgradeNum />} />
                  <Route path="/device/maintenance" element={<DeviceMaintenance />} />
                  <Route path="/device/maintenance/detail" element={<MaintenanceDetail />} />
                  <Route path="/device/statistics" element={<DeviceStatistics />} />
                  <Route path="/device/groups" element={<DeviceGroups />} />

                  {/* ... other routes ... */}
                  <Route path="/product/audit" element={<ProductAudit />} />
                  <Route path="/product/audit/manage" element={<ProductManage />} />
                  <Route path="/product" element={<ProductDevelop />} />
                  <Route path="/product/develop" element={<ProductDetail />} />
                  <Route path="/product/info" element={<ProductInformation />} />
                  <Route path="/product/app" element={<AppConfigDetail />} />
                  <Route path="/product/network-unit" element={<NetworkUnit />} />
                  <Route path="/product/referenced" element={<ReferencedProductList />} />
                  <Route path="/product/ecosystem" element={<EcosystemList />} />
                  <Route path="/package/service" element={<PackageManage />} />
                   <Route path="/package/template" element={<PackageCombination />} />
                   <Route path="/package/app-package" element={<AppPackage />} />
                  <Route path="/package/gift" element={<PackageGift />} />
                   <Route path="/package/admin" element={<PackageSwitch />} />
                    <Route path="/package/transfer" element={<PackageTransfer />} />
                   
                    {/* 运营管理 */}
                    <Route path="/operation/mall" element={<MallOperation />} />
                    <Route path="/operation/mall/packageConfig" element={<MallPackageConfig />} />
                    <Route path="/operation/recommend" element={<RecommendOperation />} />
                    <Route path="/operation/custom-sale" element={<CustomSaleEntry />} />
                    <Route path="/operation/custom-sale/config" element={<CustomSaleConfig />} />
                    <Route path="/operation/user-segment" element={<UserSegment />} />
                    <Route path="/operation/trial-convert" element={<TrialConvert />} />
                    <Route path="/operation/ad-slot" element={<GlobalAdSlot />} />
                    <Route path="/operation/ad-strategy" element={<GlobalAdStrategy />} />
                    <Route path="/operation/ad-platform" element={<AdPlatformManage />} />
                    <Route path="/operation/coupon" element={<CouponList />} />
                    <Route path="/operation/coupon/issue" element={<CouponIssueRecords />} />
                    <Route path="/operation/coupon/records" element={<CouponRecords />} />
                    <Route path="/finance/exchangeRate" element={<ExchangeRate />} />
                  
                  {/* 订单管理 */}
                  <Route path="/order/services" element={<ValueAddedOrder />} />
                  <Route path="/order/4g" element={<FourGOrder />} />
                  <Route path="/order/production/auth" element={<ProduceAuthPurchase />} />
                   <Route path="/order/company/production" element={<EnterpriseProducePurchase />} />
                  
                  {/* 4G管理 */}
                  <Route path="/4g/cardDefinition" element={<VendorDefinition />} />
                  <Route path="/4g/cardDealerConfig" element={<VendorManage />} />
                  <Route path="/4g/cardConfig" element={<CardManage />} />
                  
                   {/* 应用 */}
                    <Route path="/app/manage" element={<AppManage />} />
                    <Route path="/app/manage/operation-config/:appId" element={<OperationConfig />} />
                    <Route path="/app/audit" element={<AppAudit />} />
                    <Route path="/app/audit/manage" element={<AppManageList />} />
                    <Route path="/app/merchant-platform" element={<PlatformMerchant />} />
                    <Route path="/app/merchant-enterprise" element={<EnterpriseMerchant />} />
                    <Route path="/app/private-deploy" element={<PrivateDeploy />} />
                    <Route path="/app/private-deploy-audit" element={<PrivateDeployAudit />} />
                    <Route path="/app/oem-custom" element={<MyCustom />} />
                    <Route path="/app/oem-custom/detail/:id" element={<CustomDetail />} />
                    <Route path="/app/oem-custom-audit" element={<CustomManage />} />
                    <Route path="/app/oem-custom-audit/detail/:id" element={<CustomDetailAudit />} />
                    <Route path="/app/self-saas" element={<SelfSaaS />} />
                    <Route path="/app/saas-audit" element={<SaaSAudit />} />

                    {/* Agent工厂 */}
                    <Route path="/agent/events" element={<TriggerEventManage />} />
                    <Route path="/agent/list" element={<AgentList />} />
                    <Route path="/agent/config/:id" element={<AgentConfig />} />
                    <Route path="/agent/models" element={<ModelManage />} />

                    {/* 精准广告策略 */}
                    <Route path="/ad/whitelist" element={<AdWhitelist />} />
                  
                  {/* 费用中心 */}
                  <Route path="/cost/consumption/account" element={<ConsumptionAccount />} />
                  <Route path="/cost/invoices" element={<InvoiceCenter />} />
                  <Route path="/cost/invoices/manage" element={<InvoiceManagePage />} />
                  <Route path="/cost/invoices/apply" element={<InvoiceApply />} />
                   <Route path="/cost/income" element={<IncomeAccount />} />
                   <Route path="/cost/income/withdraw" element={<IncomeWithdraw />} />
                

                   {/* 平台账务 */}
                     <Route path="/finance/rechargAudit" element={<RechargeAudit />} />
                     <Route path="/finance/direct-topup" element={<DirectTopup />} />
                     <Route path="/finance/creditLimit" element={<CreditLimit />} />
                   <Route path="/finance/invoice" element={<InvoiceManage />} />
                   <Route path="/finance/withdrawal/audit" element={<WithdrawAudit />} />

                    {/* 抽佣管理 */}
                    <Route path="/finance/commission/order" element={<BillManage />} />
                    <Route path="/finance/ad-commission/order" element={<AdCommissionBill />} />
                    <Route path="/finance/private-deploy-bill" element={<PrivateDeployBill />} />

                    {/* 设备流量计费 */}
                    <Route path="/finance/traffic-group" element={<TrafficGroup />} />
                    <Route path="/cost/traffic-bill" element={<DeviceTrafficBill />} />
                    <Route path="/cost/traffic-stat" element={<DeviceTrafficStat />} />

                    {/* 分润管理 */}
                   <Route path="/share/profit/app" element={<AppProfit />} />
                   <Route path="/share/profit/again" element={<ShareReassign />} />
                    <Route path="/share/profit/expend" element={<ShareBilling />} />
                    <Route path="/share/profit/income" element={<ShareIncome />} />
                    <Route path="/share/business-config" element={<BusinessConfig />} />
                   <Route path="/share/ad-profit/config" element={<AdProfitConfig />} />
                   <Route path="/share/ad-profit/again" element={<AdProfitAgain />} />
                   <Route path="/share/ad-profit/expend" element={<AdProfitExpend />} />
                   <Route path="/share/ad-profit/income" element={<AdProfitIncome />} />
                   <Route path="/share/ad-profit/supervise" element={<AdProfitSupervise />} />

                  {/* 全球调度 */}
                  <Route path="/dispatch/serviceRegion" element={<ServiceRegion />} />
                  <Route path="/dispatch/product" element={<ProductDispatch />} />
                  <Route path="/dispatch/device" element={<DeviceDispatch />} />
                  
                  {/* 设备分销与分润 */}
                  <Route path="/distribution/my" element={<DeviceDistribution />} />

                  {/* SDK编译服务 */}
                  <Route path="/compile/toolchain" element={<ToolchainManage />} />
                  <Route path="/compile/task" element={<CompileTask />} />
                  <Route path="/compile/sdk-version" element={<SdkVersion />} />

                  <Route path="/distribution/proxy" element={<AgentDistribution />} />

                  {/* 企业管理 */}
                   <Route path="/company/sub" element={<SubEnterprise />} />
                   <Route path="/company/brand" element={<BrandSetting />} />
                   <Route path="/company/list" element={<ChildEnterprise />} />
                   <Route path="/company/info" element={<EnterpriseInfo />} />
                  <Route path="/company/cooperation" element={<SubEnterpriseChild />} />
                  <Route path="/companyAdmin" element={<EnterpriseAdmin />} />
                  
                     {/* 经营看板（企业视角） */}
                     <Route path="/ent-data/dashboard" element={<SolutionDashboard />} />
                     <Route path="/ent-data/device-dashboard" element={<DeviceDashboard />} />
                     <Route path="/ent-data/order-dashboard" element={<OrderDashboard />} />
                     <Route path="/ent-data/ad-revenue" element={<AppAdRevenue />} />
                     <Route path="/ent-data/fourg-revenue" element={<FourGRevenue />} />
                     <Route path="/ent-data/device-brand" element={<DeviceBrand />} />

                     {/* 客服工具 */}
                     <Route path="/customer/order-query" element={<OrderQuery />} />
                     <Route path="/customer/ticket/create" element={<TicketCreate />} />
                     <Route path="/customer/ticket/my" element={<TicketMyList />} />
                     <Route path="/customer/ticket/my/detail/:ticketNo" element={<TicketMyDetail />} />
                    <Route path="/customer/crm" element={<CustomerList />} />
                    <Route path="/customer/crm/detail/:enterpriseId" element={<CustomerDetail />} />
                     <Route path="/customer/crm/tags" element={<TagManage />} />
                     <Route path="/customer/ticket-manage" element={<TicketList />} />
                     <Route path="/customer/ticket-manage/detail/:ticketNo" element={<TicketDetail />} />
                     <Route path="/customer/agent-manage" element={<AgentAccountList />} />
                     <Route path="/customer/service-system" element={<Placeholder title="客服系统" />} />
                     <Route path="/customer/service-tracking" element={<ServiceTracking />} />

                    {/* 流量池配置 */}
                    <Route path="/traffic/pool" element={<PoolManage />} />
                    <Route path="/traffic/card" element={<TrafficCardManage />} />
                    <Route path="/traffic/package" element={<TrafficPackageList />} />
                    <Route path="/traffic/package/create" element={<TrafficPackageEdit />} />
                    <Route path="/traffic/package/edit/:id" element={<TrafficPackageEdit />} />
                    <Route path="/traffic/order" element={<TrafficOrderList />} />

                   {/* 权限管理 */}
                   <Route path="/root/menu" element={<MenuConfig />} />
                   <Route path="/companyRole" element={<MenuGroup />} />
                   <Route path="/insideRole" element={<GeneralRoleManagement />} />
                    <Route path="/insideAccount" element={<AccountManagement />} />
                    <Route path="/release-notes" element={<ReleaseNotes />} />

                     {/* 日志审计 */}
                    <Route path="/audit-log" element={<AuditLog />} />
                    <Route path="/audit-log/platform" element={<AuditLog />} />

                    {/* 发版公告时间轴（企业侧） */}
                    <Route path="/announcement" element={<TimelinePage />} />

                </Routes>
              </MainLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
